"use client";
import React, { useEffect, useState } from "react";
import { APPLICATION_ID } from "@/constants";
import { useSearchParams } from "next/navigation";
import { useDriverApplication } from "@/store/hooks/application";

let url: any = "";

if (process.env.NEXT_PUBLIC_NODE_ENV === "local") {
  url = process.env.NEXT_PUBLIC_BACKEND_LOCAL_BASE_URL;
} else if (process.env.NEXT_PUBLIC_NODE_ENV === "development") {
  url = process.env.NEXT_PUBLIC_BACKEND_DEVELOPMENT_BASE_URL;
} else if (process.env.NEXT_PUBLIC_NODE_ENV === "staging") {
  url = process.env.NEXT_PUBLIC_BACKEND_STAGING_BASE_URL;
} else if (process.env.NEXT_PUBLIC_NODE_ENV === "production") {
  url = process.env.NEXT_PUBLIC_BACKEND_PRODUCTION_BASE_URL;
}

type Props = {
  setApplicationData?: any;
};

const PageHeadDataFetcher = ({ setApplicationData }: Props) => {
  const searchParams = useSearchParams();
  const PARAMS_APPLICATION_ID = searchParams.get(APPLICATION_ID);

  const [applicationId, setApplicationId] = useState<any>("");
  const { data: applicationData } = useDriverApplication(applicationId);

  useEffect(() => {
    if (PARAMS_APPLICATION_ID) {
      setApplicationId(PARAMS_APPLICATION_ID);
    } else if (localStorage.getItem(APPLICATION_ID)) {
      setApplicationId(localStorage.getItem(APPLICATION_ID));
    }
  }, [PARAMS_APPLICATION_ID, APPLICATION_ID]);

  // useEffect(() => {
  //   if (applicationId) {
  //     // const fetchApplicationData = async () => {
  //     //   try {
  //     //     const response = await fetch(
  //     //       `${url}/api/v1/application/get-driver-application/${applicationId}`
  //     //     );
  //     //     if (!response.ok) {
  //     //       throw new Error("Failed to fetch application data");
  //     //     }
  //     //     const data = await response.json();

  //     //     setApplicationData(data?.data?.application);
  //     //   } catch (error: any) {
  //     //     // setError(error.message);
  //     //   } finally {
  //     //     // setLoading(false);
  //     //   }
  //     // };

  //     // fetchApplicationData();
  //   }
  // }, [applicationId]);

  useEffect(() => {
    if (applicationData && applicationData?.name) {
      setApplicationData(applicationData);
    }
  }, [applicationData]);

  return null;
};

export default PageHeadDataFetcher;
